import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageLoader } from "../../../../components/loaders/pageLoader";
import { EmptyState } from "../../../../components/states/emptyState";
import {
  useGetMembershipPaymentInfoMutation,
  useVerifyMembershipPaymentInfoMutation,
} from "../../../../redux/features/cooperative/cooperative.api";
import { payStackPopup } from "../../../../utils/constants";

export const PayMembershipFee = ({
  cooperativeId,
}: {
  cooperativeId: number;
}) => {
  const [paymentError, setPaymentError] = useState<{
    hasError: boolean;
    error: string;
  }>({
    hasError: false,
    error: "Oops! Something went wrong",
  });

  const navigate = useNavigate();

  const pageLoaded = useRef<boolean>(false);

  const [
    getPaymentInfo,
    { isLoading: fetchingPayment, isError: fetchPaymentError },
  ] = useGetMembershipPaymentInfoMutation();

  const [
    verifyPayment,
    { isLoading: verifyingPayment, isSuccess: paymentSuccess },
  ] = useVerifyMembershipPaymentInfoMutation();

  const doPayment = async () => {
    if (!fetchingPayment) {
      const resp = await getPaymentInfo({
        coop: cooperativeId,
      });

      if (resp.data?.success && resp.data.data.access_code) {
        payStackPopup.resumeTransaction(
          resp.data.data.access_code,
          // @ts-ignore
          {
            onSuccess: async (successData) => {
              const verifyResp = await verifyPayment({
                coop: cooperativeId,
                trxref: successData.trxref,
                reference: successData.reference,
                regPaymentId: resp.data.data.id,
              });

              if (verifyResp.data?.success) {
                navigate("/app/my-cooperatives");
              }
            },
            onError: () => {
              setPaymentError({
                hasError: true,
                error:
                  "Something went wrong while processing your payment. Please try again.",
              });
            },
            onCancel: () => {
              setPaymentError({
                hasError: true,
                error: "You canceled the payment.",
              });
            },
          }
        );
      }
    }
  };

  useEffect(() => {
    if (!pageLoaded.current) {
      pageLoaded.current = true;
      doPayment();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="w-full h-fit py-10 flex items-center justify-center">
      {fetchingPayment || verifyingPayment ? <PageLoader /> : undefined}

      {!fetchingPayment &&
      !verifyingPayment &&
      (fetchPaymentError || paymentError.hasError) ? (
        <EmptyState
          image={
            <img
              src={"/assets/images/empty_state_coming_soon.svg"}
              alt="empty"
            />
          }
          title={
            fetchPaymentError
              ? "Oops! Something went wrong"
              : paymentError.error
          }
          subtitle={
            fetchPaymentError
              ? "If the problem continues, please reach out to your cooperative officials for help."
              : ""
          }
          actionText="Try again"
          actionButtonVariant="secondary"
          onClick={() => {
            doPayment();
          }}
        />
      ) : undefined}

      {paymentSuccess ? (
        <div className="w-full flex flex-col items-center justify-center">
          <img
            src={"/assets/images/success.svg"}
            alt="success"
            className="w-full max-w-[224px] mt-4"
          />

          <p className="mt-[16px] w-full text-center text-lg font-bold">
            Payment Successful
          </p>

          {/* <p className="mt-1 text-sm text-pry-dark-green-300/80 w-full text-center">
            You’ve successfully paid{" "}
            <span className="font-medium text-pry-green-200">₦5,000</span> as a
            membership fee to join{" "}
            <span className="font-medium text-pry-green-200">₦5,000</span>.
            You’ll be redirected to the cooperative page
          </p> */}
        </div>
      ) : undefined}
    </div>
  );
};
